module.exports = __webpack_public_path__ + "196f7e2632f37ed1ba88980c526be7a2.svg";